import { useMemo, useState } from 'react'
import {
  getPalletAreaStatistics,
  getPalletAreaTimeline,
} from '../../../../services/api/https/deliveries/rastreabilidade-pallet.http'
import { errorHandler } from '../../../../services/util/error.service'
import {
  urlReportTagPickingClienteCodigoBarrasSingle,
  urlReportTagPickingGrupoProdutoCodigoBarrasSingle,
} from '../../../../services/api/routes/picking.routes'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  TRACKING: 'Rastreando pallet',
}

const INITIAL_STATE = {
  palletNumber: '',
  pallet: {
    status: '',
    qte_caixas: '',
    created_at: '',
    picking_name: '',
    pickingarea_id: null,
    pickingarea_name: '',
    vehicle_badge: '',
    driver_name: '',
    endereco: '',
    items: [
      {
        product_code: '',
        product_name: '',
        biped_by: '',
        qte_biped: '',
      },
    ],
    movimentacoes: [],
  },
  timeline: [],
  palletExcluido: false,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: '',
  warningMessage: '',
}

export default function useRastreabilidadePallet() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      getPalletInfos(tpId, palletNumber) {
        Promise.all([
          getPalletAreaStatistics(tpId, palletNumber),
          // Pallets antigos podem não possuir eventos registrados
          getPalletAreaTimeline(palletNumber).catch(() => []),
        ])
          .then(([palletStats, timeline]) => {
            // Pallet excluído do sistema, mas com timeline registrada
            const palletExcluido = palletStats.deleted === true
            setState(prevState => ({
              ...prevState,
              pallet: palletExcluido ? { ...INITIAL_STATE.pallet } : palletStats,
              palletExcluido,
              timeline: timeline || [],
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      onChange(palletNumber) {
        setState(prevState => ({ ...prevState, palletNumber: palletNumber }))
      },

      onBtnClicked(tpId, palletNumber) {
        if (tpId) {
          if (palletNumber.trim() !== '')
            setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.TRACKING }))
          else
            setState(prevState => ({
              ...prevState,
              errorMessage: 'O numero do pallet deve ser indicado',
            }))
        } else
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um operador logístico' }))
      },

      onBtnGerarTagPalletSingle(palletNumber) {
        window.open(urlReportTagPickingClienteCodigoBarrasSingle(palletNumber), '_blank')
      },

      onBtnGerarTagPalletGrupoProdutoSingle(palletNumber) {
        window.open(urlReportTagPickingGrupoProdutoCodigoBarrasSingle(palletNumber), '_blank')
      },

      clearWarningMessage() {
        setState(prevState => ({ ...prevState, warningMessage: '' }))
      },
    }
  }, [])

  return { state, localDispatch }
}
